/* eslint-disable */
import { Box, useMatchBreakpoints, Text, Flex, Button, useModal, ChevronDownIcon } from '@noahswap/uikit'
import { useWeb3React } from '@noahswap/wagmi'
import styled from 'styled-components'
import Page from 'views/Page'
import NumericalInput from 'components/CurrencyInputPanel/NumericalInput'
import { useEffect, useCallback, useState } from 'react'
import { DoubleCurrencyLogo } from 'views/Info/components/CurrencyLogo'
import { useTranslation } from '@noahswap/localization'
import { useActiveChainId } from 'hooks/useActiveChainId'
import useDebounce from 'hooks/useDebounce'
import Bribe from 'config/abi/Bribe.json'
import { useOtherContract } from 'hooks/useContract'
import { parseUnits } from '@ethersproject/units'
import { ApprovalState, useApproveCallback } from 'hooks/useApproveCallback'
import { useSigner } from 'wagmi'
import { Contract } from '@ethersproject/contracts'
import ResultModal from 'components/ResultModal'
import { useTransactionAdder } from 'state/transactions/hooks'
import { useGasPrice } from 'state/user/hooks'
import { transactionErrorToUserReadableMessage } from 'utils/transactionErrorToUserReadableMessage'
import { Currency, CurrencyAmount, JSBI, Token } from '@noahswap/sdk'
import { useTokenBalances } from 'state/wallet/hooks'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { CommitButton } from 'components/CommitButton'
import { calculateGasMargin } from 'utils'
import CoinModal from './components/CoinModal'
import LiquidityModal from './components/LiquidityModal'

const Wrap = styled.div<{ isMobile?: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '100%' : '1100px')};
  margin-bottom: 100px;
  position: relative;
  z-index: 10000;
`
const Cont = styled.div<{ isMobile?: boolean }>`
  display: flex;
  width: 100%;
  justify-content: ${({ isMobile }) => (isMobile ? 'center' : 'space-between')};
  .cont-cls {
    width: 420px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
const BoxWrap = styled.div<{ isMobile?: boolean }>`
  flex: 1;
`
const WrapCont = styled.div<{ isMobile?: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '100%' : '550px')};
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 30px;
  padding: ${({ isMobile }) => (isMobile ? '20px' : '20px 40px')};
`
const InputWrap = styled.div<{ isMobile?: boolean }>`
  background: #fff;
  border-radius: 20px;
  padding: ${({ isMobile }) => (isMobile ? '0 20px' : '0 20px')};
`
const LabelRow = styled.div<{ width?: string }>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};
  font-size: 0.75rem;
  line-height: 1rem;
  padding: 20px 0 20px 0;
  width: ${({ width }) => width || '100%'};
  input::placeholder {
    font-size: 20px;
  }
`

export default function Bribery() {
  const { account } = useWeb3React()
  const gasPrice = useGasPrice()
  const { data: signer } = useSigner()
  const { isXxxxl } = useMatchBreakpoints()
  const isMobile = !isXxxxl
  const { t } = useTranslation()
  const [coin, setCoin] = useState<any>({})
  const [coinAddress, setCoinAddress] = useState<any>({})
  const [numInput, setNumInput] = useState<any>()
  const { isWrongNetwork } = useActiveChainId()
  const debounceNumInput = useDebounce(numInput, 200)
  const [{ attemptingTxn, briberyErrorMessage, txHash }, setBriberyState] = useState<{
    attemptingTxn: boolean
    briberyErrorMessage: string | undefined
    txHash: string | undefined
  }>({
    attemptingTxn: false,
    briberyErrorMessage: undefined,
    txHash: undefined,
  })
  const addTransaction = useTransactionAdder()
  let noahClass: any = null
  const typedValueParsed = parseUnits(debounceNumInput || '0', coin?.currency?.decimals || 18).toString()
  if (typedValueParsed !== '0') {
    noahClass = CurrencyAmount.fromRawAmount(coin?.currency || {}, JSBI.BigInt(typedValueParsed))
  }
  const [approval, approveCallback] = useApproveCallback(noahClass || {}, coinAddress?.bribe)
  const coinBalances = useTokenBalances(account ?? undefined, [coin?.currency])[coin?.currency?.address]
  const [onPresentLiquidityModal] = useModal(
    <LiquidityModal coinAddress={coinAddress} setCoinAddress={setCoinAddress} />,
    true,
    true,
    'LiquidityModal',
  )
  const [onPresentCoinModal] = useModal(<CoinModal coin={coin} setCoin={setCoin} />, true, true, 'CoinModal')
  // const BribeOtherContract = useOtherContract(coinAddress?.bribe || '', Bribe)

  // console.log(coin, 'coin')
  // console.log(coinAddress?.bribe, 'coinAddress?.bribe')
  // console.log(approval, 'approval')
  useEffect(() => {
    if (!coin?.currency) {
      setNumInput('')
      return
    }
    // eslint-disable-next-line no-restricted-properties
    if (coin?.currency && Number(numInput) > Math.pow(10, 18)) {
      // eslint-disable-next-line no-restricted-properties
      setNumInput(Math.pow(10, 18).toString())
    }
  }, [debounceNumInput, coin, numInput])
  const handleCreate = async () => {
    if (!coin?.currency?.address || !coinAddress?.bribe) return
    if (approval === ApprovalState.NOT_APPROVED) {
      approveCallback()
      return
    }
    let BribeOtherContract = null
    if (coinAddress?.bribe) {
      BribeOtherContract = new Contract(coinAddress?.bribe, Bribe, signer)
    }
    // const BribeContract = await BribeOtherContract.notifyRewardAmount(coin?.address, parseUnits(debounceNumInput, 18).toString())
    let estimate = null
    let method = null
    let args = null
    estimate = BribeOtherContract.estimateGas.notifyRewardAmount
    method = BribeOtherContract.notifyRewardAmount
    args = [coin?.currency.address, parseUnits(debounceNumInput || '0', 18).toString()]
    setBriberyState({ attemptingTxn: true, briberyErrorMessage: undefined, txHash: undefined })
    onPresentResultModal()
    await estimate(...args)
      .then((estimatedGasLimit) =>
        method(...args, {
          gasLimit: calculateGasMargin(estimatedGasLimit),
          // gasLimit: 400000,
          gasPrice,
        }).then((response) => {
          console.log(response, 'responseresponse')
          setBriberyState({ attemptingTxn: false, briberyErrorMessage: undefined, txHash: response.hash })
          addTransaction(response, {
            summary: 'Bribery',
            translatableSummary: {
              text: t('Create a %num% %coin% bribe', {
                num: debounceNumInput,
                coin: coin?.currency?.symbol,
              }),
              data: {},
            },
            type: 'bribery',
          })
          // setTimeout(() => {
          //   setNumInput('')
          // }, 4000)
        }),
      )
      .catch((err) => {
        console.log(err, 'errrrrr')
        if (err && err.code !== 4001) {
          console.error(`Bribery failed`, err)
          setBriberyState({
            attemptingTxn: false,
            briberyErrorMessage: err.message,
            txHash: undefined,
          })
        }
        setBriberyState({
          attemptingTxn: false,
          briberyErrorMessage:
            err && err.code !== 4001
              ? t('Bribery failed: %message%', { message: transactionErrorToUserReadableMessage(err, t) })
              : undefined,
          txHash: undefined,
        })
      })
  }
  const buttonText = (): any => {
    // 请选择流动池
    if (!coinAddress?.bribe) {
      return t('noah433')
    }
    // 请选择币种
    if (!coin?.currency?.address) {
      return t('noah434')
    }
    // console.log(Number(debounceNumInput), '111')
    // console.log(Number(coin?.toSignificant()), '222')
    // 余额不足
    if (Number(debounceNumInput) > Number(coinBalances?.toSignificant())) {
      return t('Insufficient %coin% balance', {
        coin: coin?.currency?.symbol,
      })
    }
    // 授权
    if (approval === ApprovalState.NOT_APPROVED) {
      return `${t('noah410')} ${coin?.currency?.symbol}`
    }
    if (!Number(debounceNumInput)) {
      // 请输入数量
      return t('noah303')
    }
    return t('noah78')
  }

  const pendingText = t('Create a %num% %coin% bribe', {
    num: debounceNumInput,
    coin: coin?.currency?.symbol,
  })
  const clearInput = () => {
    setNumInput('')
  }
  const [onPresentResultModal] = useModal(
    <ResultModal
      pendingText={pendingText}
      hash={txHash}
      attemptingTxn={attemptingTxn}
      errorMessage={briberyErrorMessage}
      // 创建成功
      successText={t('noah381')}
      // 创建失败
      failText={t('noah382')}
      clearInput={clearInput}
      isSuccess={() => {
        console.log('successGetdata1111111111111')
        // getData()
        // setTimeout(() => {
        //   setNumInput('')
        // }, 5000);
      }}
    />,
    false,
    true,
    'ResultModal',
  )
  return (
    <Page footer={false} style={{ paddingTop: !isMobile ? '50px' : '' }} isMobile={isMobile}>
      <Wrap isMobile={isMobile}>
        {/* 创建贿赂 */}
        <Text fontSize={isMobile ? '20px' : '20px'} fontWeight="600" mb="5px">
          {t('noah346')}
        </Text>
        {/* 提供激励措施来吸引选票，并最大限度地增加流动池的esNOAH释放量 */}
        <Text fontSize={isMobile ? '14px' : '14px'} mb="50px">
          {t('noah347')}
        </Text>
        {/* 内容 */}
        <Cont isMobile={isMobile}>
          <WrapCont style={{ padding: isMobile ? '16px' : '20px' }}>
            <InputWrap isMobile={isMobile}>
              <Flex>
                {/* 流动池 */}
                <LabelRow width="50%">
                  <Text>{t('noah286')}</Text>
                </LabelRow>
                <LabelRow
                  width="50%"
                  style={{ flexDirection: 'row-reverse', cursor: 'pointer' }}
                  onClick={() => {
                    onPresentLiquidityModal()
                  }}
                >
                  <Flex alignItems="center">
                    {coinAddress?.bribe ? (
                      <Flex alignItems="center">
                        {coinAddress?.price_direction == 1 ? (
                          <DoubleCurrencyLogo
                            token0={{
                              address: coinAddress?.contract1,
                              symbol: coinAddress?.symbol1,
                            }}
                            token1={{
                              address: coinAddress?.contract0,
                              symbol: coinAddress?.symbol0,
                            }}
                            size={30}
                          />
                        ) : (
                          <DoubleCurrencyLogo
                            token0={{
                              address: coinAddress?.contract0,
                              symbol: coinAddress?.symbol0,
                            }}
                            token1={{
                              address: coinAddress?.contract1,
                              symbol: coinAddress?.symbol1,
                            }}
                            size={30}
                          />
                        )}

                        {coinAddress?.price_direction == 1 ? (
                          <Flex style={{ marginLeft: '30px' }}>
                            <Text>{coinAddress?.symbol1}</Text>
                            <Text color="#92929B">/{coinAddress?.symbol0}</Text>
                          </Flex>
                        ) : (
                          <Flex style={{ marginLeft: '30px' }}>
                            <Text>{coinAddress?.symbol0}</Text>
                            <Text color="#92929B">/{coinAddress?.symbol1}</Text>
                          </Flex>
                        )}
                      </Flex>
                    ) : (
                      // 选择流动池
                      <Text fontSize={isMobile ? '15px' : '15px'}>{t('noah435')}</Text>
                    )}
                    <ChevronDownIcon />
                  </Flex>
                </LabelRow>
              </Flex>
            </InputWrap>
            <InputWrap style={{ background: '#FAFAFA', marginTop: '15px' }}>
              <Flex
                justifyContent="space-between"
                style={{ padding: '20px 0 0', cursor: 'pointer' }}
                onClick={() => {
                  setNumInput(coinBalances?.toSignificant() || '0')
                }}
              >
                {/* 激励 */}
                <Text small>{t('noah348')}</Text>
                {/* 余额：xxxxx */}
                {coin?.currency?.address ? (
                  <Text color="#85868A" small>
                    {t('noah312')}：{coinBalances?.toSignificant() || '-'}
                  </Text>
                ) : (
                  <></>
                )}
              </Flex>
              <Flex>
                <LabelRow>
                  <NumericalInput
                    align="left"
                    fontSize={isMobile ? '20px' : '20px'}
                    // placeholder={t('noah265')}
                    value={numInput}
                    onUserInput={(val: any) => {
                      setNumInput(val)
                    }}
                  />
                </LabelRow>
                <LabelRow
                  width={isMobile ? '90%' : '55%'}
                  style={{ flexDirection: 'row-reverse', cursor: 'pointer' }}
                  onClick={() => {
                    onPresentCoinModal()
                  }}
                >
                  <ChevronDownIcon />
                  {coin?.currency?.address ? (
                    <Flex alignItems="center">
                      <Box mr="5px">
                        <DoubleCurrencyLogo token0={coin?.currency} size={30} />
                      </Box>
                      <Text fontSize={isMobile ? '16px' : '18px'} color="#333">
                        {coin?.currency?.symbol}
                      </Text>
                    </Flex>
                  ) : (
                    // 選擇幣種
                    <Text fontSize={isMobile ? '15px' : '15px'}>{t('noah142')}</Text>
                  )}
                </LabelRow>
              </Flex>
            </InputWrap>
            {numInput && coin?.currency?.address && coinAddress?.bribe && (
              <Text fontSize="13px" mt="25px" textAlign="center" color="#14162A">
                {/* 你正在创造一个{numInput} {coin?.currency?.symbol}的贿赂来激励选民投票给 {coinAddress?.symbol0}/
                {coinAddress?.symbol1}流动池。 */}
                {t('You are creating a %num% %coin% bribe to incentivize voters to vote for %pool% pools.', {
                  num: (numInput * 0.9).toFixed(1),
                  coin: coin?.currency?.symbol,
                  pool: `${coinAddress?.symbol0}/${coinAddress?.symbol1}`,
                })}
              </Text>
            )}
            {!account ? (
              <ConnectWalletButton style={{ width: '100%', marginTop: '25px' }}>{t('noah346')}</ConnectWalletButton>
            ) : isWrongNetwork ? (
              <CommitButton style={{ marginTop: '25px' }} />
            ) : (
              <Button
                width="100%"
                mb="0px"
                mt="25px"
                onClick={() => {
                  handleCreate()
                }}
                disabled={
                  !coin?.currency?.address ||
                  !coinAddress?.bribe ||
                  !Number(debounceNumInput) ||
                  approval === ApprovalState.PENDING ||
                  Number(debounceNumInput) > Number(coinBalances?.toSignificant())
                }
              >
                {buttonText()}
              </Button>
            )}
          </WrapCont>
          {!isMobile && (
            <div className="cont-cls">
              <img src="/images/small-img/create.png" alt="" />
            </div>
          )}
        </Cont>
      </Wrap>
    </Page>
  )
}
